import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.845 12.073 16 16 28.713 3.327c1.927 2.065 2.454 4.582 2.454 4.582.334 1.386.55 2.79.678 4.164m-3.134 16.599L16 16l15.83 3.923a32 32 0 0 1-.697 4.201s-.52 2.49-2.422 4.548M3.312 3.302 16 15.95.175 12.028a32 32 0 0 1 .691-4.153s.525-2.51 2.446-4.573M.158 19.926 16 16 3.288 28.672C1.387 26.613.866 24.124.866 24.124a29 29 0 0 1-.708-4.198",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M7.218.945c1.59-.443 3.787-.727 6.13-.86L16 16zm6.13 30.969c-2.342-.132-4.54-.416-6.13-.86L15.988 16zM18.652.086c2.33.133 4.518.418 6.122.873L16 16zm6.126 30.98c-1.593.454-3.792.727-6.136.853L16 16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20.667 16a4.667 4.667 0 1 0-9.334 0 4.667 4.667 0 0 0 9.334 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M20 16a4 4 0 1 0-8 0 4 4 0 0 0 8 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMkd = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMkd_default = SvgFlagMkd;

export { FlagMkd_default as default };
